<template>
    <div>
        <h2>Vendor List</h2>
        <ElDivider/>

        <el-form ref="form" :model="queryForm" label-width="80px" inline style="text-align: center">
            <el-form-item label="Name">
                <el-input v-model="queryForm.name" clearable></el-input>
            </el-form-item>
            <el-button type="primary" icon="el-icon-search" circle @click="loadData"></el-button>
        </el-form>

        <el-table
                stripe
                @row-click="openEdit"
                v-loading="loading"
                :data="data" align="center"
                style="width: 100%">
            <el-table-column header-align="center"
                             align="center" v-for="(item,index) in [ {prop:'email',label:'Email'},
                       {prop:'supplier.bid',label:'ID'},
                      {prop:'mobile',label:'Mobile'},
                      {prop:'address',label:'Address'},
                      {prop:'name',label:'Name'},]"
                             :prop="item.prop"
                             :label="item.label"
                             :key="index">
            </el-table-column>

            <el-table-column
                    align="center"
                    label="Role">
                <template slot-scope="s">
                    <template v-if="s.row.supplier">
                        <el-tag v-if="s.row.supplier.role===1" type="success">Personal</el-tag>
                        <el-tag v-if="s.row.supplier.role===2" type="success">Company</el-tag>
                        <el-tag v-if="s.row.supplier.role===3" type="success">Employee</el-tag>
                    </template>
                </template>
            </el-table-column>

            <el-table-column
                    align="center"
                    label="Status">
                <template slot-scope="s">
                    <template v-if="s.row.supplier">
                        <el-tag v-if="s.row.supplier.status===1" type="success">Normal</el-tag>
                        <el-tag v-if="s.row.supplier.status===0" type="danger">Forbidden</el-tag>
                        <el-tag v-if="s.row.supplier.status===2" type="warning">New</el-tag>
                    </template>
                </template>
            </el-table-column>
        </el-table>
        <div class="page">
            <el-pagination v-if="page.total>1"
                           @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>
        <vendor-modify-dialog :id="editId" v-if="edVisible" :visible.sync="edVisible"></vendor-modify-dialog>
    </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
    import {vendorList, forbidVendor} from '@/api/VendorAPI'
    import vendorModifyDialog from './VendorModifyDialog'

    export default {
        name: 'VendorList',
        components: {vendorModifyDialog},
        data() {
            return {
                loading: false,
                data: [],
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
                editId: -1,
                edVisible: false,
                queryForm: {}
            }
        },
        methods: {
            loadData() {
                this.$pageUtils(this, vendorList)
            },
            openEdit(data) {
                this.editId = data.supplierId
                this.edVisible = true
            },
            forbid(id) {
                forbidVendor(id)
                    .then(res => {
                        if (res.status === 200) {
                            this.$msg.success('Success')
                        }
                    })
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>

</style>
